export default "__VITE_ASSET__mFYHt_RW__"